import React from 'react';
import CardContent from '../components/CardContent';

export default function Home() {
    return <CardContent />;
}
